import {Directive, EventEmitter, Input, Output, QueryList} from "@angular/core";
import {FUIOptionsService, SelectionEvent, SelectionsEvent} from "./options.service";

@Directive()
export abstract class FUIAbstractOptions {
    @Input() public field: string; // The field containing the data
    @Input() public key: string; // Key is the label of the selection
    /**
     * Defines the label for the option to clear the selection
     */
    @Input() public clearSelectionOptionLabel: string;
    @Input() public allowClearSelectionOption: boolean = true;
    @Input() public optionOpenable: boolean;
    @Output() public optionOpened$: EventEmitter<any>;
    private _options: Array<any>; // Unfiltered list of options
    private _filteredOptions: Array<any>; // Filtered list of options
    @Input() public selection: any;
    @Output() public selection$: EventEmitter<SelectionEvent>;
    protected _selections: Array<any>;
    @Output() public selections$: EventEmitter<SelectionsEvent>;
    @Output() public changeSelections$: EventEmitter<SelectionsEvent>;

    private filteredOptionsSet: boolean = false;

    constructor(protected optionsService: FUIOptionsService) {
        this._options = [];
        this._filteredOptions = [];
        this.selection$ = new EventEmitter<SelectionEvent>();
        this._selections = [];
        this.selections$ = new EventEmitter<SelectionsEvent>();
        this.optionOpened$ = new EventEmitter<any>();
        this.changeSelections$ = new EventEmitter<SelectionsEvent>();
    }

    /**
     *
     * @returns {QueryList<FUIOptionComponent>}
     */
    get options(): Array<any> {
        if (this._options) {
            return this._options;
        }

        return new Array<any>();
    }

    /**
     * Set both the valid options list and the filterable
     * list in case filtering is not being used. If filtering
     * is being used then the new input will be sent via filteredOptions
     * @param {QueryList} options
     */
    @Input()
    set options(options: Array<any>) {
        this._options = options;
        if (!this.filteredOptionsSet) {
            this.setFilteredOptions(options);
        }
    }


    get filteredOptions(): Array<any> {
        return this._filteredOptions;
    }

    @Input()
    set filteredOptions(filteredOptions: Array<any>) {
        this.setFilteredOptions(filteredOptions);
        this.filteredOptionsSet = true;
    }

    protected setFilteredOptions(filteredOptions: Array<any>): void {
        this._filteredOptions = filteredOptions;
    }

    /**
     *
     * @returns {Array<any>}
     */
    get selections(): Array<any> {
        return this._selections;
    }

    /**
     *
     * @param {Array<any>} selections
     */
    @Input()
    set selections(selections: Array<any>) {
        if (selections !== this._selections) {
            this._selections = selections;
            this.optionsService.selections = selections;
        }
    }

    /**
     * Check if the list of options is empty
     * @returns {boolean}
     */
    public empty(options: Array<any>): boolean {
        if (options) {
            if (options.length > 0) {
                return false;
            } else {
                return true;
            }
        }

        return true;
    }

    /**
     * Check if the list of options is empty
     * @returns {boolean}
     */
    public filled(options: Array<any>): boolean {
        if (options) {
            if (options.length > 0) {
                return true;
            } else {
                return false;
            }
        }

        return false;
    }
}
